import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const TiktokIcon = ({ color = 'currentColor', className = null }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            fill={color}
            d="M9 1.01924e-05L10.9806 0C11.1236 0.715011 11.5206 1.61706 12.215 2.51195C12.8955 3.3888 13.7971 4.00001 15 4.00001V6.00001C13.2466 6.00001 11.9291 5.18645 11 4.17139V11C11 13.7614 8.76142 16 6 16C3.23858 16 1 13.7614 1 11C1 8.23859 3.23858 6.00001 6 6.00001V8.00001C4.34315 8.00001 3 9.34316 3 11C3 12.6569 4.34315 14 6 14C7.65685 14 9 12.6569 9 11V1.01924e-05Z"
        />
    </svg>
);

TiktokIcon.propTypes = propTypes;

export default TiktokIcon;
